import React from 'react';
import EnhancedHero from '../components/EnhancedHero';
import Enhanced3DServices from '../components/Enhanced3DServices';
import ProjectsTeaser from '../components/ProjectsTeaser';
import AnimatedStats from '../components/AnimatedStats';
import Enhanced3DAbout from '../components/Enhanced3DAbout';
import InteractiveTimeline from '../components/InteractiveTimeline';
import Contact from '../components/Contact';

const HomePage: React.FC = () => (
  <>
    <EnhancedHero />
    <Enhanced3DServices />
    <ProjectsTeaser />
    <AnimatedStats />
    <Enhanced3DAbout />
    <InteractiveTimeline />
    <Contact />
  </>
);

export default HomePage;
